import { InjectionToken } from '@angular/core';

/** I18n config Injection Token */
export const LANGUAGES_API_URL_TOKEN: InjectionToken<string> = new InjectionToken(
  'LANGUAGES_API_URL_TOKEN',
);
